<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CXxp4H/cover.jpeg?1684515197995" alt="This image is the cover for the book Chat Groups of the Three Realms, Volume 2"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Chat Groups of the Three Realms, Volume 2
      </h1>
      <p class="bookDescription body article font2">
        <p>Zhang Le was a person without a job. He had unintentionally obtained the QQ group of the Heavenly Court and his life had thus changed. He would be courting girls, opening a drug factory, opening a company, and from then on, he would be at the pinnacle of his life.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Xian Danchaoren, Babel Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?560c2b53